// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GcpGke } from './GcpGke';
import {
  GcpGkeFromJSON,
  GcpGkeFromJSONTyped,
  GcpGkeToJSON,
  GcpGkeToJSONTyped,
} from './GcpGke';
import type { GcpNetwork } from './GcpNetwork';
import {
  GcpNetworkFromJSON,
  GcpNetworkFromJSONTyped,
  GcpNetworkToJSON,
  GcpNetworkToJSONTyped,
} from './GcpNetwork';

/**
 *
 * @export
 * @interface GcpSpec
 */
export interface GcpSpec {
  /**
   *
   * @type {GcpGke}
   * @memberof GcpSpec
   */
  gke?: GcpGke;
  /**
   *
   * @type {GcpNetwork}
   * @memberof GcpSpec
   */
  network?: GcpNetwork;
}

/**
 * Check if a given object implements the GcpSpec interface.
 */
export function instanceOfGcpSpec(value: object): value is GcpSpec {
  return true;
}

export function GcpSpecFromJSON(json: any): GcpSpec {
  return GcpSpecFromJSONTyped(json, false);
}

export function GcpSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GcpSpec {
  if (json == null) {
    return json;
  }
  return {
    gke: json['gke'] == null ? undefined : GcpGkeFromJSON(json['gke']),
    network:
      json['network'] == null ? undefined : GcpNetworkFromJSON(json['network']),
  };
}

export function GcpSpecToJSON(json: any): GcpSpec {
  return GcpSpecToJSONTyped(json, false);
}

export function GcpSpecToJSONTyped(
  value?: GcpSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    gke: GcpGkeToJSON(value['gke']),
    network: GcpNetworkToJSON(value['network']),
  };
}
